import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";

import AppLayout from "../../layout/AppLayout";
import gogo from "./dashboard";

import { firestore } from "../../helpers/Firebase";
import audioFile from '../../helpers/sound.mp3';
import { accessTypes, accessTypesObject, requestPermission } from "../../helpers/Utils";
import { ORDER_COLLECTION } from "../../config/env";
import { RATED_ORDERS_ROLES, RATED_ORDERS_VIEW_ROLES } from "./appointments/components/complaint";
import { setChatsCount, setComplaintsCount, setMessagesCount, setUserFromRequests } from "../../redux/chat/actions";
import Admins from './admins';
import { default as Appointments, default as Requests } from './appointments';
import Chat from "./chat";
import CRM from './CRM';
import Marketing from './marketing';
import Providers from './providers';
import Services from './services';
import Settings from './settings';
import Subscriptions from './subscriptions';
import UpSelling from './up-selling';
import VehiclesCategories from './vehicles';
import Washers from './washers';
const beep = new Audio(audioFile)

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentWillMount() {
    let authUser = this.props.authUser;
    console.log("authUser", authUser);
    let _this = this;
    let unsubscribeMessagesRef;
    let unsubscribeCountRef;
    let unsubscribeComplaintsRef;

    if (authUser) {
      // Rated Orders (RATED_ORDERS_PLAN.md §5.1): sidebar badge = open low-rating complaints,
      // and a beep + desktop alert when a new one lands (same pattern as the chat alert above).
      // Providers get the badge for their own bookings only, without the alert.
      if (RATED_ORDERS_VIEW_ROLES.includes(authUser?.accessType)) {
        let complaintsFirstRun = true;
        const alertsOn = RATED_ORDERS_ROLES.includes(authUser?.accessType);
        let complaintsRef = firestore().collection(ORDER_COLLECTION).where('complaintOpen', '==', true);
        if (!alertsOn) complaintsRef = complaintsRef.where('sp_id', '==', authUser?.uid);
        unsubscribeComplaintsRef = complaintsRef
          .onSnapshot(snap => {
            _this.props.setComplaintsCount(snap.size);
            if (!complaintsFirstRun && alertsOn) {
              snap.docChanges().filter(c => c.type === 'added').forEach(c => {
                const b = c.doc.data() || {};
                beep.play().catch(() => { });
                if ("Notification" in window && Notification.permission === "granted") {
                  const n = new Notification(`Low rating ${b.rate != null ? b.rate + '/5 ' : ''}from ${b.customer_name || 'a customer'}`, { body: `${b.sp_name || ''} · ${b.service_name || ''}${b.reason ? ` — ${b.reason}` : ''}` });
                  n.onclick = (event) => {
                    event.preventDefault();
                    window.focus();
                    _this.props.history.push(`/app/orders/rated?order=${encodeURIComponent(c.doc.id)}`);
                    n.close();
                  };
                }
              });
            }
            complaintsFirstRun = false;
          }, err => console.log('complaints listener error', err && err.message));
      } else {
        _this.props.setComplaintsCount(0);
      }
      let isFirstRun = true;
      let messagesRef = firestore().collectionGroup('messages')
      if (!accessTypes.includes(authUser?.accessType)) {
        messagesRef = messagesRef.where('provider_id', '==', authUser?.uid)
      }

      unsubscribeMessagesRef = messagesRef.orderBy("created", "desc")
        .limit(1)
        .onSnapshot(snap => {
          let data = snap.docs?.[0]?.data();

          if (!snap.empty && !isFirstRun && !Object.keys(accessTypesObject).includes(data?.role)) {
            let { from, created, sender, text } = data || {}
            if (created) {
              if (from && from !== 'Chill' && sender !== authUser?.uid) {
                beep.play().catch(err => {
                  console.log("errerr", err);
                })
                // Check if the browser supports notifications
                if (!("Notification" in window)) {
                  console.log("This browser does not support desktop notification");
                } else if (Notification.permission === "granted") {
                  console.log("Notification permission granted");

                  let notification = new Notification(`New message received from ${from}`, { body: text?.body || '' });
                  notification.onclick = function (event) {
                    event.preventDefault(); // prevent the browser from focusing the Notification's tab
                    window.focus(); // focus the browser tab where the application is running
                    _this.props.setUserFromRequests(`${(from).replace(/\D/g, '')}`)
                    _this.props.history.push('/app/chat'); // Change the URL without reloading the page
                    notification.close(); // close the notification
                  }
                } else if (Notification.permission === "denied") {
                  requestPermission()
                }
              }

            }
          }
          isFirstRun = false;
        });
      let newMessagesCountRef = firestore().collection('chats').where('newCount', '>', 0)
      if (!accessTypes.includes(authUser?.accessType)) {
        newMessagesCountRef = newMessagesCountRef.where('provider_id', '==', authUser?.uid)
      }

      unsubscribeCountRef = newMessagesCountRef.onSnapshot(snap => {
        if (!snap.empty) {

          let totalNewCount = 0;
          let totalChatsCount = 0;
          snap.docs.forEach(doc => {
            // totalNewCount += Number(doc?.data()?.newCount || 0);
            // totalChatsCount += Number(doc?.data()?.newCount || 0);
            const newCount = Number(doc?.data()?.newCount || 0);
            totalNewCount += newCount;
            if (newCount > 0) {
              totalChatsCount += 1;
            }
          });
          _this.props.setMessagesCount(totalNewCount);
          _this.props.setChatsCount(totalChatsCount);

        } else {
          _this.props.setMessagesCount(0);
          _this.props.setChatsCount(0);
        }
      });
    } else {
      if (unsubscribeMessagesRef) {
        unsubscribeMessagesRef()
      }
      if (unsubscribeCountRef) {
        unsubscribeCountRef()
      }
      if (unsubscribeComplaintsRef) {
        unsubscribeComplaintsRef()
      }
    }
  }

  render() {
    const { match, authUser } = this.props;
    return (
      <AppLayout>
        <Switch>

          <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`} />
          <Route path={`${match.url}/dashboard`} component={gogo} />
          <Route path={`${match.url}/providers`} component={Providers} />
          <Route path={`${match.url}/crm`} component={CRM} />
          {accessTypes.includes(authUser?.accessType) && <Route path={`${match.url}/marketing`} component={Marketing} />}
          {accessTypes.includes(authUser?.accessType) && <Route path={`${match.url}/services`} component={Services} />}
          <Route path={`${match.url}/up-selling`} component={UpSelling} />

          {authUser?.accessType === 'superAdmin' && <Route path={`${match.url}/admins`} component={Admins} />}
          {authUser?.accessType === 'superAdmin' && <Route path={`${match.url}/settings`} component={Settings} />}

          <Route path={`${match.url}/workers`} component={Washers} />
          <Route path={`${match.url}/orders`} component={Requests} />
          <Route path={`${match.url}/orders`} component={Appointments} />
          <Route path={`${match.url}/subscriptions`} component={Subscriptions} />
          <Route path={`${match.url}/vehicles`} component={VehiclesCategories} />
          <Route path={`${match.url}/chat`} component={Chat} />

          <Redirect to="/error" />
        </Switch>


      </AppLayout>
    );
  }
}

const mapStateToProps = ({ menu, authUser }) => {
  const { containerClassnames } = menu;
  return {
    containerClassnames,
    authUser: authUser?.user

  };
};
const mapActionsToProps = (dispatch) => ({
  setMessagesCount: (user) => dispatch(setMessagesCount(user)),
  setChatsCount: (user) => dispatch(setChatsCount(user)),
  setComplaintsCount: (n) => dispatch(setComplaintsCount(n)),
  setUserFromRequests: (user) => dispatch(setUserFromRequests(user))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(App)
);
